import { useState, useRef, useCallback } from 'react';
import { generateAndDownloadCSV } from '@freight-cbm/shared-logic';
import { useAppStore } from '@/store/store';
import { selectShipmentSummary } from '@/store/selectors';
import { useClickOutside } from '@/hooks/useClickOutside';

export function ExportMenu() {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const closeMenu = useCallback(() => setOpen(false), []);
  useClickOutside(menuRef, closeMenu);

  const handleCSV = () => {
    const state = useAppStore.getState();
    const summary = selectShipmentSummary(state);
    generateAndDownloadCSV(state.packages, summary);
    setOpen(false);
  };

  const handlePrint = () => {
    window.print();
    setOpen(false);
  };

  return (
    <div ref={menuRef} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        className="btn btn-sm"
        onClick={() => setOpen(!open)}
        aria-haspopup="true"
        aria-expanded={open}
      >
        Export
      </button>
      {open && (
        <div
          role="menu"
          style={{
            position: 'absolute',
            right: 0,
            top: '100%',
            marginTop: 'var(--space-1)',
            background: 'var(--color-bg-primary)',
            border: '1px solid var(--color-border)',
            borderRadius: 'var(--radius-md)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 100,
            minWidth: 160,
            overflow: 'hidden',
          }}
        >
          <button
            type="button"
            role="menuitem"
            className="btn btn-sm"
            onClick={handleCSV}
            style={{ width: '100%', textAlign: 'left', justifyContent: 'flex-start', borderRadius: 0 }}
          >
            Download CSV
          </button>
          <button
            type="button"
            role="menuitem"
            className="btn btn-sm"
            onClick={handlePrint}
            style={{ width: '100%', textAlign: 'left', justifyContent: 'flex-start', borderRadius: 0 }}
          >
            Print / PDF
          </button>
        </div>
      )}
    </div>
  );
}
